import {Exceptions as CommonExceptions} from '../../../common/constants'
import {Exceptions} from '../../../panels/user/editTeamAssignmentsPanel/constants'

export function rpcErrorHandler(rpcError) {
    rpcError.handleOnExceptions([
        ...Object.values(Exceptions),
        CommonExceptions.NO_RIGHTS_TO_SUBMIT_TT_EXCEPTION,
        CommonExceptions.WORK_ASSIGNMENTS_FEATURE_DISABLED_EXCEPTION
    ])
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentPanel/utils.js